<template>
  <div>
    <el-form class="kewen-form" ref="form" label-width="80px">
      <el-form-item label="等级">
        <el-select filterable v-model="form.level" placeholder="等级">
          <el-option
              v-for="item in $store.state.levels"
              :key="item.id"
              :label="item.name"
              :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="课程编号">
        <el-input v-model="form.num"></el-input>
      </el-form-item>
      <el-form-item label="名称">
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item label="名称">
        <el-input v-model="form.pinyin"></el-input>
      </el-form-item>
      <el-form-item label="图像">
        <FileInput v-model="form.avatar" accept="image/*"></FileInput>
      </el-form-item>
      <el-form-item label="姓别">
        <el-radio-group v-model="form.gender">
          <el-radio v-for="(item, key) in genders" :key="key" :label="item.id">{{ item.name }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="应用场景">
        <el-checkbox label="情景对话" v-model="form.for_dht"></el-checkbox>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import FileInput from '../FileInput.vue'

export default {
  name: 'KewenRoleForm',
  components: {FileInput},
  data() {
    return {
      form: {},
      genders: [
        {id: 1, name: '男'},
        {id: 2, name: '女'}
      ]
    }
  },
  methods: {
    reset(model) {
      this.form = Object.assign({
        id: null,
        level: null,
        num: null,
        name: '',
        pinyin: '',
        avatar: '',
        for_dht: 0,
      }, model)
    },
    submit() {
      const params = {
        level: this.form.level,
        name: this.form.name,
        pinyin: this.form.pinyin,
        num: this.form.num,
        avatar: this.form.avatar,
        gender: this.form.gender,
        for_dht: this.form.for_dht
      };
      if (this.form.id) {
        return this.$http.put(this.$urls.kewen_role_update, params, {
          params: {id: this.form.id}
        })
      } else {
        return this.$http.post(this.$urls.kewen_role_create, params).then(data => {
          this.form.id = data.data.id
        })
      }
    }
  }
}
</script>
